import { useAccordion, Rows } from '../../design-system'
import { useToggle } from 'react-use'
import React, { ReactNode } from 'react'
import { BoxProps } from '../../design-system'
import { ExpandContractGraphic } from '../graphics'
import { Box } from '../../design-system'
import { InlineButton } from '../atoms'

interface TagAccordionProps extends BoxProps {
  label?: ReactNode
  analyticsEvent?: string
  rowBorder?: string
}

export const TagAccordion = ({
  label,
  children,
  analyticsEvent,
  ...boxProps
}: TagAccordionProps) => {
  const [open, toggleOpen] = useToggle(false)
  const accordion = useAccordion(open, { minHeight: '85px' })

  return (
    <Rows spacing={2} {...boxProps}>
      <Box overflow="hidden" style={accordion.spring}>
        <Box ref={accordion.contentRef}>{children}</Box>
      </Box>

      <InlineButton
        onClick={toggleOpen}
        prefixView={
          <ExpandContractGraphic
            mode={open ? 'minus' : 'plus'}
            thickness={2}
            width="1em"
          />
        }
      >
        {open ? 'Less Tags' : 'More Tags'}
      </InlineButton>
    </Rows>
  )
}
